import React from 'react'
import { Table } from 'antd'
import MapWithAMarker from './map'
import { Redirect } from 'react-router'
import Enquiry from './ClientEnquiry'
import * as columns from './columns'

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  clientEnquiry() {
    if (this.props.user.role === 'admin') {
      return (
        <Enquiry QualityPlans={this.props.QualityPlans} selectedEnquiry={this.selectedEnquiry} />
      )
    }
  }

  selectedEnquiry(val) {
    console.log(val);
  }

  render() {
    var postData = [];
    if (this.props.posts) {
      for (var i = 0; i < this.props.posts.length; i++) {
        if (this.props.user.role === 'admin') {
          if (this.props.posts[i].form_values["762b"]) {
            var jobNo = this.props.posts[i].form_values.ec4e + " | " + this.props.posts[i].form_values["762b"];
          } else {
            jobNo = this.props.posts[i].form_values.ec4e;
          }
          postData.push({
            id: this.props.posts[i].id,
            job: jobNo,
            activity: this.props.posts[i].form_values["9e7a"],
            date: this.props.posts[i].form_values.b6e0,
            time: this.props.posts[i].form_values.dabf,
            poster: this.props.posts[i].form_values.e247.choice_values["0"]
          });
        }
        else if (this.props.user.role === 'client') {
          if (this.props.posts[i].form_values.d149 === this.props.user.username) {
            if (this.props.posts[i].form_values["762b"]) {
              jobNo = this.props.posts[i].form_values.ec4e + " | " + this.props.posts[i].form_values["762b"];
            } else {
              jobNo = this.props.posts[i].form_values.ec4e;
            }
            postData.push({
              id: this.props.posts[i].id,
              job: jobNo,
              activity: this.props.posts[i].form_values["9e7a"],
              date: this.props.posts[i].form_values.b6e0,
              time: this.props.posts[i].form_values.dabf,
              poster: this.props.posts[i].form_values.e247.choice_values["0"]
            });
          }
        }
      }
      postData.sort((a, b) => {
        var aDate = a.date;
        var bDate = b.date;

        return (aDate > bDate) ? -1 : 1;
      });
    }
    function checkData() { if (postData.length === 0) { return true } else { return false } }
    var oneYear = new Date();
    oneYear.setDate(oneYear.getDate() - 365);
    var oneYearInput = oneYear.toISOString();

    let data = [];
    if (this.props.QualityPlans && this.props.user.username !== null) {
      for (var q = 0; q < this.props.QualityPlans.length; q++) {
        if (this.props.user.role === 'admin') {
          if (this.props.QualityPlans[q].form_values["5e22"] >= oneYearInput && this.props.QualityPlans[q].latitude !== null) {
            data.push(this.props.QualityPlans[q]);
          }
        }
        else if (this.props.user.role === 'client') {
          if (this.props.QualityPlans[q].form_values["6f71"] === this.props.user.username && this.props.QualityPlans[q].form_values["5e22"] >= oneYearInput && this.props.QualityPlans[q].latitude !== null) {
            data.push(this.props.QualityPlans[q])
          }
        }
      }
      data.sort((a, b) => {
        var aDate = a.form_values.b059;
        var bDate = b.form_values.b059;

        return (aDate > bDate) ? -1 : 1;
      });
    }
    if (this.props.user.role === 'maintenance') {
      return <Redirect to='/maintenance' />
    }

    return (
      <div>
        {this.clientEnquiry()}

        {/* 
        TODO: 
        1) Add table next to admin posts and updates 
          FOR Admin roles to show events for today
          -- Color Indicator 
          -- Title
          -- Description
        2) Make nessasary tables searchable
          if (this.state.search) {
            data = data.filter(row => {
              return row.firstName.includes(this.state.search) || row.lastName.includes(this.state.search) || String(row.age).includes(this.state.search)
            })
          }
           */}
        <h2>Admin Posts / Updates</h2>
        <Table
          pagination={{ position: 'bottom', pageSize: 4 }}
          bordered
          id='postTable'
          loading={checkData()}
          className='tableResizer'
          columns={columns.POSTS}
          dataSource={postData}
          rowKey='id'
          size="middle"
        />

        <MapWithAMarker
          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyALSdb8pDixxuFtKtAHTfss_cW7bvI6IOY&v=3.exp&libraries=geometry,drawing,places"
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={
            <div
              style={{
                height: `380px`,
                border: '1px solid #e8e8e8',
                borderRadius: '4px'
              }}
            />}
          mapElement={<div style={{ height: `100%` }} />}
          QualityPlans={data}
        />
      </div>
    )
  }
}

export default Home;
